import { Diagnosis } from '../hypothesis'
import { isEmpty } from 'lodash'

export default [
  {
    /** @type {Diagnosis} */
    diagnosis(answers, patient) {
      const diagnosis = {
        general: () => {
          if (answers['12'] == 'alta' && !isEmpty(answers['10'])) {
            return true
          }

          if (answers['12'] == 'alta' && !isEmpty(answers['13'])) {
            return true
          }

          return false
        },
        child: () => {
          if (['alta', 'media'].includes(answers['12']) && !isEmpty(answers['10'])) {
            return true
          }

          if (['alta', 'media'].includes(answers['12']) && !isEmpty(answers['13'])) {
            return true
          }

          return false
        },
      }

      const diagnosisMethod = patient.age >= 12 ? 'general' : 'child'

      if (diagnosis[diagnosisMethod]?.()) {
        return {
          text: 'grave',
          proceed: true,
        }
      }

      return {
        proceed: false,
      }
    },
    version: {
      /** @type {number[]} */
      include: [],
      /** @type {number[]} */
      exclude: [],
    },
  },
]
